import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { getBrutalistStyles } from '../../styles/brutalist';

const WelcomeDialog = ({ isOpen, onClose }) => {
  const { isDarkMode } = useTheme();
  const { student } = useAuth();
  const brutalistStyles = getBrutalistStyles(isDarkMode);

  if (!isOpen || !student) return null;

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '1rem'
  };

  const modalStyle = {
    backgroundColor: isDarkMode ? '#000' : '#fff',
    border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
    boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`,
    transform: 'translate(-2px, -2px)',
    width: '100%',
    maxWidth: '450px',
    padding: '1.25rem',
    textAlign: 'center'
  };

  const titleStyle = {
    ...brutalistStyles.brutalistTitle,
    fontSize: '1.75rem',
    marginBottom: '1rem'
  };

  const messageStyle = {
    fontSize: '1.1rem',
    marginBottom: '1.5rem',
    lineHeight: 1.4
  };

  // Calculate remaining days
  const calculateRemainingDays = () => {
    const now = new Date();
    const expiryDate = new Date(student.expiresAt);
    const diffTime = Math.abs(expiryDate - now);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>
        <h2 style={titleStyle}>¡BIENVENIDO!</h2>
        <div style={messageStyle}>
          <p>¡Bienvenido {student.name}!</p>
          <p>Tu cuenta premium está activa.</p>
          <p>Te quedan {calculateRemainingDays()} días de acceso.</p>
        </div>
        <button
          onClick={onClose}
          style={{
            ...brutalistStyles.brutalistButton,
            backgroundColor: '#4CAF50',
            color: '#fff',
            padding: '0.75rem 2rem',
            fontSize: '1rem'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translate(-4px, -4px)';
            e.target.style.boxShadow = isDarkMode ? '8px 8px 0 #fff' : '8px 8px 0 #000';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translate(-3px, -3px)';
            e.target.style.boxShadow = isDarkMode ? '6px 6px 0 #fff' : '6px 6px 0 #000';
          }}
        >
          CONTINUAR
        </button>
      </div>
    </div>
  );
};

export default WelcomeDialog;